import { render, staticRenderFns } from "./AppearanceSettings.vue?vue&type=template&id=028ed28b&"
import script from "./AppearanceSettings.vue?vue&type=script&lang=js&"
export * from "./AppearanceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports